export default __webpack_public_path__ + "static/media/header2.cd213d4a.jpg";